import { Box, Stack } from '@mui/material';
import { type FC } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const RatingEntryPageSkeleton: FC = () => {
    return (
        <Page back={true} insetEnabled={false}>
            <Stack height="100%" sx={{ background: 'var(--tgui--secondary_bg_color)', paddingTop: 'var(--tg-viewport-content-safe-area-inset-top, 0px)' }}>
                <Box sx={{ borderRadius: '16px', padding: '20px', margin: '16px', backgroundColor: 'var(--tg-theme-section-bg-color)' }}>
                    <Stack direction="row" alignItems="center" gap={1.5}>
                        <ThemedSkeleton variant="circular" width={24} height={24} />
                        <Stack direction="column" gap={0.5}>
                            <ThemedSkeleton variant="rectangular" width={150} height={24} sx={{ borderRadius: 1 }} />
                            <ThemedSkeleton variant="rectangular" width={100} height={16} sx={{ borderRadius: 1 }} />
                        </Stack>
                    </Stack>
                </Box>
                <Stack sx={{ flex: 1, padding: '16px' }}>
                    <ThemedSkeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: 2, mb: 2 }} />
                    <Stack direction="row" justifyContent="space-between" gap={1}>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                            <ThemedSkeleton key={n} variant="rectangular" width={28} height={48} sx={{ borderRadius: 1 }} />
                        ))}
                    </Stack>
                </Stack>
            </Stack>
        </Page>
    );
};

